<rask-datepicker
    [appendToBody]="appendToBody"
    [label]="labelStartDate"
    maxDate="{{endDate}}"
    [(ngModel)]="periodStart"
    [onlyMonths]="onlyMonths"
    [disabled]="disableDatePicker"
    aid="{{aid + 'Start'}}">
</rask-datepicker>
<rask-datepicker
    [appendToBody]="appendToBody"
    [label]="labelEndDate"
    minDate="{{startDate}}"
    [(ngModel)]="periodEnd"
    [onlyMonths]="onlyMonths"
    [disabled]="disableDatePicker"
    aid="{{aid + 'End'}}">
</rask-datepicker>
